import { useCallback, useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import type { RecipeUUID } from '@library/menu-service'

import { incrementTutorialViewed } from 'actions/tutorial'
import { useBasket } from 'routes/Menu/domains/basket'
import { getHasSeenFlexEducationTooltip } from 'routes/Menu/selectors/basket'
import { getIsAuthenticated } from 'selectors/auth'

export const useRecipeGridFlexEducation = () => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(getIsAuthenticated)
  const hasSeenFlexEducationTooltip = useSelector(getHasSeenFlexEducationTooltip)
  const { recipeCount } = useBasket()
  const [flexEducationRecipeId, setFlexEducationRecipeId] = useState<RecipeUUID | null>(null)

  const onRecipeAdded = useCallback(
    (recipeId: RecipeUUID) => {
      if (isAuthenticated && !hasSeenFlexEducationTooltip && recipeCount === 0) {
        setFlexEducationRecipeId(recipeId)
      }
    },
    [hasSeenFlexEducationTooltip, isAuthenticated, recipeCount],
  )

  const closeFlexEducationTooltip = useCallback(() => {
    dispatch(incrementTutorialViewed('flex-education-tooltip'))
    setFlexEducationRecipeId(null)
  }, [dispatch])

  useEffect(() => {
    if (recipeCount !== 1) {
      setFlexEducationRecipeId(null)
    }
  }, [recipeCount])

  const visibleFlexEducationRecipeId =
    isAuthenticated && !hasSeenFlexEducationTooltip && recipeCount === 1
      ? flexEducationRecipeId
      : null

  return {
    closeFlexEducationTooltip,
    flexEducationRecipeId: visibleFlexEducationRecipeId,
    onRecipeAdded,
  }
}
